import {
  CHANGE_STEP,
  CHANGE_ANALYSIS_TAB,
  FETCH_RESULT,
  FETCH_RESULT_SUCCESS,
  FETCH_RESULT_FAILED,
  FETCH_ALL_RESULT,
  FETCH_ALL_RESULT_SUCCESS,
  FETCH_ALL_RESULT_FAILED,
  FETCH_ADMIN_RESULT,
  FETCH_ADMIN_RESULT_SUCCESS,
  FETCH_ADMIN_RESULT_FAILED,
  DELETE_ADMIN_RESULT,
  DELETE_ADMIN_RESULT_FAILED,
  DELETE_ADMIN_RESULT_SUCCES,
  FETCH_DRIVERS,
  FETCH_DRIVERS_FAILED,
  FETCH_DRIVERS_SUCCESS
} from "./constants";

import db from "../../firebaseAPI";

function changeStepRequest(step) {
  return {
    type: CHANGE_STEP,
    payload: {
      step
    }
  };
}

export function changeStep(step) {
  return dispatch => {
    dispatch(changeStepRequest(step));
  };
}

// Chart analysis tab
function changeAnalysisTabRequest(tab) {
  return {
    type: CHANGE_ANALYSIS_TAB,
    payload: {
      tab
    }
  };
}

export function changeAnalysisTab(tab) {
  return dispatch => {
    dispatch(changeAnalysisTabRequest(tab));
  };
}

// get the result data

export function fetchDriversRequest() {
  return {
    type: FETCH_DRIVERS,
    payload: {}
  };
}

export function fetchDriversSuccess(data) {
  return {
    type: FETCH_DRIVERS_SUCCESS,
    payload: {
      data
    }
  };
}

export function fetchDriversFailed(payload) {
  return {
    type: FETCH_DRIVERS_FAILED,
    payload: {
      data: { ...payload }
    }
  };
}

export function fetchDrivers(evaluationId) {
  return dispatch => {
    dispatch(fetchResultRequest());
    return db
      .collection("drivers")
      .where("transactionalanalysisId", "==", evaluationId)
      .get()
      .then(function(snap) {
        const data = snap.docs.map(doc => ({
          id: doc.id,

          ...doc.data()
        }));

        dispatch(fetchDriversSuccess(data));
      })
      .catch(function(error) {
        dispatch(fetchDriversFailed(error));
      });
  };
}

export function fetchResultRequest() {
  return {
    type: FETCH_RESULT,
    payload: {}
  };
}

export function fetchResultSuccess(data) {
  return {
    type: FETCH_RESULT_SUCCESS,
    payload: {
      data
    }
  };
}

export function fetchResultFailed(payload) {
  return {
    type: FETCH_RESULT_FAILED,
    payload: {
      data: { ...payload }
    }
  };
}

export function fetchResult(evaluationId) {
  return dispatch => {
    dispatch(fetchResultRequest());
    return db
      .collection("evaluations")
      .doc(evaluationId)
      .get()
      .then(function(doc) {
        if (!!{ ...doc.data() }.answers) {
          const data = { id: doc.id, ...doc.data() };

          dispatch(fetchResultSuccess(data));
        } else {
          db.collection("drivers")
            .doc(evaluationId)
            .get()
            .then(function(driver) {
              const data = { id: driver.id, ...driver.data() };

              dispatch(fetchResultSuccess(data));
            });
        }
      })
      .catch(function(error) {
        dispatch(fetchResultFailed(error));
      });
  };
}

export function fetchAllResultRequest() {
  return {
    type: FETCH_ALL_RESULT,
    payload: {}
  };
}

export function fetchAllResultSuccess(data) {
  return {
    type: FETCH_ALL_RESULT_SUCCESS,
    payload: {
      data
    }
  };
}

export function fetchAllResultFailed(payload) {
  return {
    type: FETCH_ALL_RESULT_FAILED,
    payload: {
      data: { ...payload }
    }
  };
}

export function fetchAllResults() {
  return dispatch => {
    dispatch(fetchAllResultRequest());
    return db
      .collection("evaluations")
      .get()
      .then(function(snap) {
        const evaluationData = snap.docs.map(doc => ({
          id: doc.id,

          ...doc.data()
        }));

        db.collection("drivers")
          .get()
          .then(function(snap) {
            const driverData = snap.docs.map(doc => ({
              id: doc.id,

              ...doc.data()
            }));

            const data = evaluationData.concat(driverData);

            dispatch(fetchAllResultSuccess(data));
          });
      })
      .catch(function(error) {
        dispatch(fetchAllResultFailed(error));
      });
  };
}

export function fetchAdminResultRequest() {
  return {
    type: FETCH_ADMIN_RESULT,
    payload: {}
  };
}

export function fetchAdminResultSuccess(data) {
  return {
    type: FETCH_ADMIN_RESULT_SUCCESS,
    payload: {
      data
    }
  };
}

export function fetchAdminResultFailed(payload) {
  return {
    type: FETCH_ADMIN_RESULT_FAILED,
    payload: {
      data: { ...payload }
    }
  };
}

export function fetchAdminResult(evaluationId) {
  return dispatch => {
    dispatch(fetchAdminResultRequest());
    return db
      .collection("evaluations")
      .doc(evaluationId)
      .get()
      .then(function(doc) {
        const data = { id: doc.id, ...doc.data() };
        dispatch(fetchAdminResultSuccess(data));
      })
      .catch(function(error) {
        dispatch(fetchAdminResultFailed(error));
      });
  };
}

export function deleteAdminResult(evaluationId) {
  return dispatch => {
    dispatch(deleteAdminResultRequest(evaluationId));
    return db
      .collection("evaluations")
      .doc(evaluationId)
      .delete()
      .then(function() {
        dispatch(deleteAdminResultSucces(evaluationId));
      })
      .catch(function(error) {
        dispatch(deleteAdminResultFailed(error));
      });
  };
}

export function deleteAdminResultRequest(evaluationId) {
  return {
    type: DELETE_ADMIN_RESULT,
    payload: { evaluationId }
  };
}

export function deleteAdminResultFailed(error) {
  return {
    type: DELETE_ADMIN_RESULT_FAILED,
    payload: {
      error
    }
  };
}

export function deleteAdminResultSucces(evaluationId) {
  return {
    type: DELETE_ADMIN_RESULT_SUCCES,
    payload: {
      evaluationId
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/results/actions.js